<section class="section white-100" *ngIf="_readyToData">
  <div [ngClass]="notInside ? 'section-container' : 'section-container-inside'">
    <div class="section-discover-power">
      <div class="discover-power-content">
        <div class="discover-power-heading">
          {{ _readyToData?.title }}
        </div>
        <div class="discover-power-subtext">
          {{ _readyToData?.content?.content[0]?.content[0]?.value }}
        </div>
        <div class="landing-btn">
          <a
            href="{{ _readyToData?.buttons[0]?.fields?.redirectLink | urlParams:queryParams}}"
            target="{{ _readyToData?.buttons[0]?.fields?.actionType }}"
            class="btn btn-full"
            (click)="onReadyToCTAClick()"
          >
            {{ _readyToData?.buttons[0]?.fields?.buttonText }}
          </a>
          <app-common-talktosales-button
            [text]="_readyToData?.buttons[1]?.fields?.buttonText"
          ></app-common-talktosales-button>
        </div>
      </div>
      <div class="discover-power-image">
        <img
          loading="lazy"
          [src]="_readyToData?.image[0]?.fields?.file?.url"
          alt=""
        />
      </div>
    </div>
  </div>
</section>
